import { withTheme } from '@rjsf/core';
import { generateTheme } from './Theme.js';

/** A ready-to-use @rjsf/core Form pre-wired with this library's own templates/widgets —
 * no @mui/material anywhere. Usage:
 *
 *   import Form from '@coolremote/shared';        // (re-exported as `RjsfForm`)
 *   import validator from '@rjsf/validator-ajv8';
 *   <Form schema={...} uiSchema={...} formData={...} onSubmit={...} validator={validator} />
 */
const RjsfForm = withTheme(generateTheme());

export default RjsfForm;
